import { Icon } from "@iconify/react";
import CONVERSACIONES_META from "../../conversacionesGlobales/constants";

/* ------------------------------------------------------------------ */
/*  Modal Formulario: Editar contenido de conversaciones por talento   */
/*  (versión plantel)                                                  */
/* ------------------------------------------------------------------ */

const ContenidoPlantelFormModal = ({
  talentoFilter,
  conversaciones,
  formData,
  formSaving,
  hasFilters,
  onTalentoChange,
  onClearFilters,
  onFieldChange,
  onGuardar,
  onClose,
  fetchTalentos,
  Select2,
}) => {
  const metaDe = (num) =>
    CONVERSACIONES_META[num] || {
      foco: "",
      color: "#6c757d",
      colorClaro: "#f8f9fa",
      icono: "mdi:message-outline",
    };

  return (
    <>
      {/* Filtro por talento dentro del modal */}
      <div className="d-flex align-items-center gap-2 mb-3">
        <div style={{ minWidth: "200px", maxWidth: "300px" }}>
          <Select2
            value={talentoFilter}
            onChange={onTalentoChange}
            fetchOptions={fetchTalentos}
            placeholder="Filtrar por talento..."
            isClearable
          />
        </div>
        {hasFilters && (
          <button
            onClick={onClearFilters}
            className="btn btn-outline-secondary d-flex align-items-center gap-2"
            style={{ height: "44px" }}
          >
            <Icon icon="mdi:filter-remove-outline" width="18" />
            <span className="d-none d-sm-inline">Limpiar filtro</span>
          </button>
        )}
      </div>

      {/* Infográfico horizontal de 5 columnas (editable) */}
      <div className="radius-12 overflow-hidden border">
        {/* ===== Fila 1: Encabezados de columna ===== */}
        <div className="row g-0">
          {conversaciones.map((conv, idx) => {
            const num = idx + 1;
            const meta = metaDe(num);
            return (
              <div
                key={`fhdr-${conv.id}`}
                className="col"
                style={{
                  flex: "1 1 0%",
                  minWidth: 0,
                  borderRight: idx < conversaciones.length - 1 ? "1px solid #e5e7eb" : "none",
                }}
              >
                <div
                  className="d-flex flex-column align-items-center text-center py-3 px-2"
                  style={{ backgroundColor: meta.colorClaro }}
                >
                  <span
                    className="rounded-circle d-flex align-items-center justify-content-center mb-2"
                    style={{
                      width: 40,
                      height: 40,
                      backgroundColor: meta.color,
                    }}
                  >
                    <Icon icon={meta.icono} width={22} className="text-white" />
                  </span>
                  <span
                    className="fw-bold mb-1"
                    style={{ color: meta.color, fontSize: "11px" }}
                  >
                    CONVERSACIÓN {num}
                  </span>
                  <span
                    className="fw-semibold"
                    style={{
                      color: meta.color,
                      fontSize: "12px",
                      lineHeight: 1.3,
                    }}
                  >
                    {conv?.label || "Sin datos"}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {/* ===== Fila 2: Propósito de la conversación ===== */}
        <div
          className="px-3 py-2 text-center"
          style={{
            backgroundColor: "#f0f4f8",
            borderTop: "1px solid #e5e7eb",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <span
            className="fw-bold text-uppercase"
            style={{ fontSize: "13px", letterSpacing: "0.5px", color: "#6b7280" }}
          >
            Propósito de la conversación
          </span>
        </div>
        <div className="row g-0">
          {conversaciones.map((conv, idx) => {
            const data = formData[conv.id] || {};
            return (
              <div
                key={`fpro-${conv.id}`}
                className="col py-2 px-2"
                style={{
                  flex: "1 1 0%",
                  minWidth: 0,
                  borderRight: idx < conversaciones.length - 1 ? "1px solid #e5e7eb" : "none",
                }}
              >
                <textarea
                  className="form-control"
                  rows={5}
                  value={data.descripcion_proposito || ""}
                  onChange={(e) =>
                    onFieldChange(conv.id, "descripcion_proposito", e.target.value)
                  }
                  style={{ fontSize: "13px", resize: "vertical" }}
                  placeholder="Propósito..."
                />
              </div>
            );
          })}
        </div>

        {/* ===== Fila 3: ¿Cómo la utilizará el Mentor? ===== */}
        <div
          className="px-3 py-2 text-center"
          style={{
            backgroundColor: "#f0f4f8",
            borderTop: "1px solid #e5e7eb",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <span
            className="fw-bold text-uppercase"
            style={{ fontSize: "13px", letterSpacing: "0.5px", color: "#6b7280" }}
          >
            ¿Cómo la utilizará el Mentor?
          </span>
        </div>
        <div className="row g-0">
          {conversaciones.map((conv, idx) => {
            const data = formData[conv.id] || {};
            return (
              <div
                key={`futi-${conv.id}`}
                className="col py-2 px-2"
                style={{
                  flex: "1 1 0%",
                  minWidth: 0,
                  borderRight: idx < conversaciones.length - 1 ? "1px solid #e5e7eb" : "none",
                }}
              >
                <textarea
                  className="form-control"
                  rows={5}
                  value={data.descripcion_utilizar || ""}
                  onChange={(e) =>
                    onFieldChange(conv.id, "descripcion_utilizar", e.target.value)
                  }
                  style={{ fontSize: "13px", resize: "vertical" }}
                  placeholder="Cómo utilizarla..."
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* Botones de acción */}
      <div className="d-flex gap-2 justify-content-end mt-3">
        <button
          className="btn btn-outline-secondary d-flex align-items-center gap-2"
          onClick={onClose}
          disabled={formSaving}
        >
          <Icon icon="mdi:close" width="18" />
          Cancelar
        </button>
        <button
          className="btn btn-primary d-flex align-items-center gap-2"
          onClick={onGuardar}
          disabled={formSaving}
        >
          {formSaving ? (
            <>
              <div className="spinner-border spinner-border-sm" role="status" />
              Guardando...
            </>
          ) : (
            <>
              <Icon icon="mdi:content-save-outline" width="18" />
              Guardar todo
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default ContenidoPlantelFormModal;
